import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CatalogContext = createContext({ products: [], loading: true, refresh: () => {}, getProduct: () => null });

export const useCatalog = () => useContext(CatalogContext);

export const CatalogProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    axios.get(`${API}/products`)
      .then(({ data }) => { setProducts(data.products || []); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const getProduct = useCallback((id) => products.find((p) => p.id === id) || null, [products]);

  return (
    <CatalogContext.Provider value={{ products, loading, refresh, getProduct }}>
      {children}
    </CatalogContext.Provider>
  );
};
